import React from 'react';
import { withRouter } from 'react-router-dom';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import { FormHandler, Input } from 'Components/Form';

import Auth from 'Services/Api/Auth/Auth';
import { User } from 'Services';

class Register extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your remote-control account has been successfully created.';

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        const { setForm } = this.props;

        setForm({
            remote_control: true
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { form, handleInput, getFieldError, handleSubmit, working, alert } = this.props;

        return (
            <Unauthenticated>
                <AuthLayout
                    title="Remote Register"
                    backLink="/login"
                    submitText="Register"
                    onSubmit={(e) => handleSubmit(e, Auth.register, null, true)}
                    working={working}
                    alert={alert}
                >
                    <div className="grid grid-cols-1 gap-4 mb-4">
                        <div>
                            <Input
                                label="First Name"
                                type="text"
                                value={form.first_name}
                                error={getFieldError('first_name')}
                                onChange={v => handleInput('first_name', v)}
                                whiteStyle={true}
                            />
                        </div>

                        <div>
                            <Input
                                label="Last Name"
                                type="text"
                                value={form.last_name}
                                error={getFieldError('last_name')}
                                onChange={v => handleInput('last_name', v)}
                                whiteStyle={true}
                            />
                        </div>
                    </div>
                </AuthLayout>
            </Unauthenticated>
        );
    }
}

export default FormHandler(withRouter(Register));
